<template>
  <div class="frontDesk">
    <div>
      <span>客户接待>客服</span>
      <el-divider></el-divider>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="80px" label-position="right" class="search-form">
        <el-form-item label="患者">
          <el-input v-model="filters.positionCode" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户类型">
          <el-select v-model="filters.client" placeholder="请选择项目类型" style="width:90%">
            <el-option v-for="item in clientType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="filters.createBy" clearable></el-input>
        </el-form-item>
        <el-form-item label="前台">
          <el-input v-model="filters.createBy" clearable></el-input>
        </el-form-item>
        <el-form-item label="客服">
          <el-input v-model="filters.createBy" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否VIP">
          <el-select v-model="filters.vip" placeholder="请选择是否VIP" style="width:90%">
            <el-option v-for="item in vipType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入关键字" v-model="filters.keyword">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger">删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning">手动刷新</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-alert type="error" :closable="false" class="alertName">
      <h3>可分配客服</h3>
      <div class="nameList">
        <div>徐大拿 19585985698</div>
        <div>徐大拿 19585985698</div>
      </div>
    </el-alert>
    <div>
      <el-alert title="10分钟以上待接待(20)" type="error" :closable="false" effect="dark"></el-alert>
      <customerChild></customerChild>
      <el-collapse v-model="activeName">
        <el-collapse-item name="1" title="5至10分钟内待接待(10)">
          <customerChild></customerChild>
        </el-collapse-item>
        <el-collapse-item name="2" title="5分钟内待接待(10)">
          <customerChild></customerChild>
        </el-collapse-item>
        <el-collapse-item name="3" title="接待中(10)">
          <customerChild></customerChild>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
import customerChild from './customerChild.vue'
export default {
  components: { customerChild },
  data() {
    return {
      filters: {},
      vipType: [
        {
          value: 0,
          label: '是'
        }, {
          value: 1,
          label: '否'
        },
      ],
      clientType: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '患者'
      }, {
        value: 2,
        label: '陪同'
      },],
      activeName: '1'
    }
  }
}
</script>
<style scoped>
.frontDesk >>> .el-collapse-item__header {
  background: #67c23a;
  border-radius: 4px;
  height: 34px;
  padding: 0 25px;
  box-sizing: border-box;
  color: #fff;
}
.alertName {
  margin-bottom: 14px;
  border: 1px solid red;
}
.nameList {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
}
.nameList div {
  margin: 5px 30px;
}
</style>